import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import Axios from "axios"
import jwt_decode from "jwt-decode";
import Logo from "../images/logo2.png"
import AppUrl from "../AppUrl/ApiUrl";

class Menu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sidemenu: "sidemenuOpen",
            content: "contentClose",
            path:"",
        }
    }

    componentDidMount() {
        var path = window.location.pathname
        this.setState({path:path})
        var token = localStorage.getItem("admintoken")
        if(token){
            var decoded = jwt_decode(token);
            var type = decoded.usertype
            if(type=="Admin"){
                this.setState({token:token})

                const formData = new FormData()
                formData.append("token",token)
                Axios.post(AppUrl.baseurl+"get-profile",formData)
                    .then(res=>{
                        if(res.data.profile.usertype=="User"){
                            localStorage.removeItem("admintoken")
                            this.props.history.push("/login")
                        }
                    })
                    .catch(err=>{
                        console.log(err)
                    })
            }else{
                this.props.history.push("/login")
            }
        }else{
            this.props.history.push("/login")
        }
    }

    menuClick = () => {
        if (this.state.sidemenu == "sidemenuOpen") {
            this.setState({ sidemenu: "sidemenuClose", content: "contentOpen" })
        } else {
            this.setState({ sidemenu: "sidemenuOpen", content: "contentClose" })
        }
    }

    logout=()=>{
        localStorage.removeItem("admintoken")
        toast.success("Logout Successful", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
        setTimeout(
            () => {
                this.props.history.push("/login")
            }, 1000
        )
    }

    render() {
        // ইনলাইন স্টাইল অবজেক্ট
        const navItemStyle = {
            display: "flex",
            alignItems: "center",
            padding: "10px 15px",
            fontSize: "14px",
            fontWeight: "500",
            color: "#374151",
            textDecoration: "none",
            borderRadius: "6px",
            marginBottom: "4px"
        };

        const iconStyle = {
            width: "24px",
            marginRight: "14px", // আইকন এবং লেখার মধ্যে গ্যাপ
            textAlign: "center",
            fontSize: "16px",
            color: "#6B7280"
        };

        return (
            <>
                <title>{this.props.title}</title>
                <div className="menu">
                    <div className="container-fluid">
                        <div className="row align-items-center">
                            <div className="col-md-2 col-6 top-logo">
                                <Link to="/">
                                    <img className="logoimage" src={Logo} alt="Logo" />
                                </Link>
                            </div>
                            <div className="col-md-10 col-6 text-right">
                                <a onClick={this.menuClick} className="menu-bar"><i className="fa fa-bars"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content-body">
                    <div className="sidebar">
                        <ul className={this.state.sidemenu} style={{ padding: "10px", listStyle: "none" }}>
                            <div className="sidelogo" style={{ marginBottom: "15px" }}>
                                <Link to="/">
                                    <img className="logoimage" src={Logo} alt="Logo" />
                                </Link>
                            </div>

                            <Link to="/" style={{ textDecoration: "none" }}>
                                <li className={this.state.path == "/" ? "active" : ""} style={navItemStyle}>
                                    <i className="fa fa-users" style={iconStyle}></i>
                                    <span>User List</span>
                                </li>
                            </Link>

                            <Link to="/currency/airdrop" style={{ textDecoration: "none" }}>
                                <li className={this.state.path == "/currency/airdrop" ? "active" : ""} style={navItemStyle}>
                                    <i className="fa fa-coins" style={iconStyle}></i>
                                    <span>Coin</span>
                                </li>
                            </Link>

                            <Link to="/package" style={{ textDecoration: "none" }}>
                                <li className={this.state.path == "/package" ? "active" : ""} style={navItemStyle}>
                                    <i className="fa fa-box-open" style={iconStyle}></i>
                                    <span>Package</span>
                                </li>
                            </Link>

                            <Link to="/info" style={{ textDecoration: "none" }}>
                                <li className={this.state.path == "/info" ? "active" : ""} style={navItemStyle}>
                                    <i className="fa fa-info-circle" style={iconStyle}></i>
                                    <span>Info</span>
                                </li>
                            </Link>

                            <Link to="/ads" style={{ textDecoration: "none" }}>
                                <li className={this.state.path == "/ads" ? "active" : ""} style={navItemStyle}>
                                    <i className="fa fa-bullhorn" style={iconStyle}></i>
                                    <span>Ads</span>
                                </li>
                            </Link>

                            <Link to="/airdrop-users" style={{ textDecoration: "none" }}>
                                <li className={this.state.path == "/airdrop-users" ? "active" : ""} style={navItemStyle}>
                                    <i className="fa fa-gift" style={iconStyle}></i>
                                    <span>Airdrop Users</span>
                                </li>
                            </Link>

                            <Link to="/payments" style={{ textDecoration: "none" }}>
                                <li className={this.state.path == "/payments" ? "active" : ""} style={navItemStyle}>
                                    <i className="fa fa-file-invoice-dollar" style={iconStyle}></i>
                                    <span>All Payments</span>
                                </li>
                            </Link>

                            <Link to="/deposit" style={{ textDecoration: "none" }}>
                                <li className={this.state.path == "/deposit" ? "active" : ""} style={navItemStyle}>
                                    <i className="fa fa-wallet" style={iconStyle}></i>
                                    <span>All Deposit</span>
                                </li>
                            </Link>

                            <Link to="/withdrew" style={{ textDecoration: "none" }}>
                                <li className={this.state.path == "/withdrew" ? "active" : ""} style={navItemStyle}>
                                    <i className="fa fa-money-check-alt" style={iconStyle}></i>
                                    <span>All Withdrew</span>
                                </li>
                            </Link>

                            <Link to="/transfer" style={{ textDecoration: "none" }}>
                                <li className={this.state.path == "/transfer" ? "active" : ""} style={navItemStyle}>
                                    <i className="fa fa-exchange-alt" style={iconStyle}></i>
                                    <span>All Transfer</span>
                                </li>
                            </Link>

                            <Link to="/withdrew/pending" style={{ textDecoration: "none" }}>
                                <li className={this.state.path == "/withdrew/pending" ? "active" : ""} style={navItemStyle}>
                                    <i className="fa fa-clock" style={iconStyle}></i>
                                    <span>Withdraw Pending</span>
                                </li>
                            </Link>

                            <Link to="/settings" style={{ textDecoration: "none" }}>
                                <li className={this.state.path == "/settings" ? "active" : ""} style={navItemStyle}>
                                    <i className="fa fa-cog" style={iconStyle}></i>
                                    <span>Settings</span>
                                </li>
                            </Link>

                            <Link to="#" style={{ textDecoration: "none" }} onClick={this.logout}>
                                <li style={navItemStyle}>
                                    <i className="fa fa-sign-out-alt" style={iconStyle}></i>
                                    <span>Logout</span>
                                </li>
                            </Link>
                            <br/><br/><br/>
                        </ul>
                    </div>
                    <div className={this.state.content}>
                        <ToastContainer
                            position="top-right"
                            autoClose={5000}
                            hideProgressBar
                            newestOnTop={false}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                        />
                        {this.props.children}
                    </div>
                </div>
            </>
        );
    }
}

export default withRouter(Menu);